export default "__VITE_ASSET__DPxoI6ra__"